import React from 'react';
import PropTypes from 'prop-types';

export const IconFalse = ({ className }) => (
  <svg className={className} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle r="8.57143" transform="matrix(-1 0 0 1 8.99888 8.99996)" fill="#D4373E" />
    <path d="M5.34616 5.46988C5.74013 5.07591 6.37888 5.07591 6.77285 5.46988L12.6567 11.3537C13.0507 11.7477 13.0507 12.3864 12.6567 12.7804C12.2627 13.1744 11.624 13.1744 11.23 12.7804L5.34616 6.89657C4.95219 6.5026 4.95219 5.86385 5.34616 5.46988Z" fill="white" />
    <path d="M12.6577 5.46988C12.2638 5.07591 11.625 5.07591 11.2311 5.46988L5.34721 11.3537C4.95324 11.7477 4.95324 12.3864 5.34721 12.7804C5.74118 13.1744 6.37993 13.1744 6.7739 12.7804L12.6577 6.89657C13.0517 6.5026 13.0517 5.86385 12.6577 5.46988Z" fill="white" />
  </svg>
);

IconFalse.propTypes = {
  className: PropTypes.string
};

IconFalse.defaultProps = {
  className: ''
};
